import { Component, input, InputSignal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

import { FaqBlockSection } from '@core/cms/landing.cms';
import { CmsImage } from '@shared/ui/cms-image/cms-image';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';

/** Renders a `ComponentSectionFaqBlock`: intro content + an accordion of question/answer items. */
@Component({
    selector: 'cms-faq-block',
    imports: [MatExpansionModule, CmsImage, TrustHtmlPipe],
    templateUrl: './faq-block.html',
    styleUrl: './faq-block.scss',
})
export class CmsFaqBlock {
    public readonly section: InputSignal<FaqBlockSection> = input.required<FaqBlockSection>();
}
